import { Box, LinearProgress, Typography } from "@mui/material"
import { CardShadow } from "../../../../../../components/Card"
import { dataCompletingProgress } from "./types"
import { useStyles } from "./styles"
import { useContextState } from "../../../../../../hooks/theme"


export const CardCompletingProgress = (props: dataCompletingProgress) => {
  const styles = useStyles()
  const { colors } = useContextState()
  
  const getColorForPercentage = (percentage: number, index: number) => {
    if (index === 0) {
      if (percentage < 61) return colors.color8
      if (percentage >= 61 && percentage <= 80) return colors.orangeMedium
      if (percentage > 80) return colors.color43
      return colors.color8
    }
    
    if (percentage <= 60) return colors.color43
    if (percentage >= 61 && percentage <= 80) return colors.orangeMedium
    if (percentage > 80) return colors.color8
    return colors.color43
  }

  return (
    <CardShadow sx={styles.cardTotals}>
      <Typography sx={{ color: props.colorTitle, ...styles.title }}> 
        {props.title}
      </Typography>
      <Box sx={styles.content}>
        <Box sx={styles.totalBox}>
          <Typography variant="h6" sx={styles.totalValue}>
            {props.total}
          </Typography>
          <Typography sx={styles.descriptionTotal}>
            {props.descriptionTotal}
          </Typography>
        </Box>
        <Box sx={styles.porcentagesContainer}>
          {props.porcentages.map((item, index) => (
            <Box key={index} sx={styles.porcentageBox}>
              <Typography sx={styles.porcentageLabel}>
                {item.label}
              </Typography>
              <LinearProgress 
                variant="determinate" 
                value={item.porcentage} 
                sx={{ 
                  ...styles.progressBar,
                  '& .MuiLinearProgress-bar': { 
                    backgroundColor: getColorForPercentage(item.porcentage, index),
                    borderRadius: '5px'
                  } 
                }} 
              />
              <Typography sx={styles.porcentageValue}>
                {item.porcentage}%
                {item.numerator !== undefined && item.denominator !== undefined && (
                  <span style={{ marginLeft: '4px' }}>({item.numerator}/{item.denominator})</span>
                )}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </CardShadow>
  )
}